import React, { useRef, useState } from "react";

import { Modal, ModalBody } from "reactstrap";
import classnames from "classnames/dedupe";
import ReactQuill from "react-quill";

import { isRichTextInputEmpty as checkRichText, RichTextInput } from "components/rich-text-input.tsx/rich-text-input";
import { GT, ModalWrapper } from "components/index";
import { getNestedObjValue } from "../helpers";

import "./edit-richtext-input.styles.scss";

export const EditRichTextInput = (props) => {
    const {
        //base
        value = undefined,
        name = undefined,
        shouldDataSetRefresh: refresh = false,
        extraEditParams = {},
        editUrl = undefined,
        secondPartEditUrl = undefined,
        className = "",
        clientSideEdit = false,
        style = {},
        editParamsBeforeChange = undefined,
        extraParametersToSet = undefined,
        urlInstanceId,
    } = props;

    const { row, fieldName, handleEditSubmit, header, isBusy, permCode = "", rowIndex } = props.inputData;

    const content = value || getNestedObjValue(row, fieldName.split("."));

    const isRichTextInputEmpty = !!content ? checkRichText(content) : true;

    const handleEdit = async (newValue) => {
        const params = editParamsBeforeChange ? editParamsBeforeChange(extraEditParams, newValue) : extraEditParams;

        const response = await handleEditSubmit({
            row: row,
            e: { target: { name: fieldName, value: newValue } },
            secondPartEditUrl: secondPartEditUrl,
            extraColumnEditParams: params,
            refresh: refresh,
            clientSideEdit: clientSideEdit,
            extraParametersToSet: extraParametersToSet,
            editUrl,
            urlInstanceId,
            reqParams: { permCode },
        });
    };

    return (
        <div
            className={classnames("rich-text-table-edit", className)}
            style={style}
            id={`prime-input-text-${fieldName}-${rowIndex}`}
            key={`prime-input-text-${fieldName}-${row.id}`}
            onKeyDown={(e) => e.stopPropagation()}
        >
            {!isRichTextInputEmpty && (
                <ModalWrapper icon={{ name: ["fas", "magnifying-glass"] }} tooltipContent={<RichTextInput value={content} readOnly />}>
                    {(modalOpen, closeModal) => (
                        <ModalContent modalOpen={modalOpen} closeModal={closeModal} value={content} readOnly name={header} />
                    )}
                </ModalWrapper>
            )}
            <ModalWrapper permCode={permCode} reqModal icon={{ name: ["fas", "pen-to-square"] }}>
                {(modalOpen, closeModal) => (
                    <ModalContent modalOpen={modalOpen} closeModal={closeModal} value={content} name={header} onEdit={handleEdit} />
                )}
            </ModalWrapper>
        </div>
    );
};

interface IModalContent {
    modalOpen: boolean;
    value: string;
    readOnly?: boolean;
    name: string;
    closeModal: () => void;
    onEdit?: (value) => void;
}

const ModalContent = ({ modalOpen, closeModal, value, readOnly, name, onEdit }: IModalContent) => {
    const rtRef = useRef<ReactQuill>(null);

    const [isBusy, setIsBusy] = useState<boolean>(false);

    const handleEdit = async () => {
        setIsBusy(true);
        onEdit && (await onEdit(rtRef.current?.props?.value));
        closeModal();
        setIsBusy(false);
    };

    return (
        <Modal isOpen={modalOpen} fade toggle={closeModal} onContextMenu={(e) => e.stopPropagation()}>
            <GT.ModalHeader closeModal={closeModal} name={name} />
            <ModalBody>
                <RichTextInput defaultValue={value} readOnly={readOnly} rtRef={rtRef} audioRecorder={!readOnly} autofocus />
            </ModalBody>
            <GT.ModalFooter
                closeModal={closeModal}
                cancelName="Close"
                okName={!readOnly ? "Save" : undefined}
                onClick={handleEdit}
                okIsBusy={isBusy}
            />
        </Modal>
    );
};
